import { DividerComponent, PaperComponent } from "@/components";
import { CurrencyConverter, FormatDateDMY, WEB_COLORS } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import React from "react";

const EmiDetailsCard = ({
  emiAmount,
  closureDate,
  firstEmiStartDate,
  totalEmiPaidAmount,
  totalEmiAmountRemaining,
}) => {
  function DetailField(header, value) {
    return (
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
      >
        <Typography color={WEB_COLORS.textFadeColor}>{header}</Typography>
        <Typography fontWeight={"bold"}>{value}</Typography>
      </Stack>
    );
  }
  return (
    <PaperComponent>
      <Stack gap={2}>
        <Typography variant="h5"> EMI Details</Typography>
        <DividerComponent orientation="horizontal" />
        {DetailField("EMI Amount", CurrencyConverter(emiAmount))}
        {DetailField("Total EMI Paid", CurrencyConverter(totalEmiPaidAmount))}
        {DetailField(
          "Total EMI Amount Remaining",
          CurrencyConverter(totalEmiAmountRemaining),
        )}
        {DetailField("First EMI Date", FormatDateDMY(firstEmiStartDate))}
        {DetailField("Last EMI Date", FormatDateDMY(closureDate))}
      </Stack>
    </PaperComponent>
  );
};

export default EmiDetailsCard;
